
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/logout",
      function () {
        return require("private-next-pages/auth/logout.js");
      }
    ]);
  